
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import axios from 'axios';
import Vue from 'vue';
import {removeToken} from '@/utils/cookie';
import api from '@/api/';
import {Message, Modal} from 'view-design';
import {getToken} from '@/utils/cookie';
import supplierRouter from "@/views/supplier/router";
import {getHrefPath, errorUrlHandel, deleteTicket, setConfigCharacters} from "@/utils/common";
import {i18n} from '@/locale';
import becomingSupplierDistributorModal from '@/components/common/becomingSupplierDistributorModal.vue';
import shoppingPerfectInformation from '@/components/common/shoppingPerfectInformation.vue';

Vue.component('Message', Message);
Vue.component('Modal', Modal);

function logoutFun() {
  axios.get(api.get_logout + getToken()).then(response => {
    if (response.data.code === 0) {
      removeToken().then(() => {
        let url = deleteTicket(window.location.href);
        url = errorUrlHandel(url);
        window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
      });
    }
  });
}

export const showNoAuth = () => {
  Modal.warning({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001700'),
    transfer: true,
    zIndex: 1000,
    content: '<p>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001701') + '</p><p>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001702') + '</p>',
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000091'),
    onOk: () => {
      const appEl = document.getElementById('app');
      if (appEl) {
        appEl.innerHTML = '';
      }
      logoutFun();
    }
  });
};

// 待确认账单的提示框
export const showBillConfirmed = () => {
  Modal.confirm({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001703'),
    transfer: true,
    zIndex: 1000,
    content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001704'),
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001705'),
    cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001706'),
    onOk: () => {
      supplierRouter.push('/reconciliationManage');
    }
  });
};

// 供应商停用提示框
export const supplierDeactivationPrompt = () => {
  Modal.warning({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001707'),
    transfer: true,
    zIndex: 1000,
    content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001692')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001693')}`,
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
    onOk: () => {
      logoutFun();
    }
  });
};

// 下单库存不足
export const insufficientInventory = (others, onOkCallback) => {
  if (others) {
    let errorMessage = others.errorMessage || '';
    let content = `<p>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001694')}<span style="color: red;">${errorMessage}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001695')}</p>`;
    Modal.warning({
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001708'),
      transfer: true,
      zIndex: 1000,
      dangerouslyUseHTMLString: true,
      content: content,
      okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
      onOk: () => {
        if (typeof onOkCallback === 'function') {
          onOkCallback();
        }
      }
    });
  }
};

// 校验当前登录到供应商系统之后判断当前商户是否是没有通过审核，如果没有通过审核自动跳转到商城--供应商入驻页面
export const auditSuppliers = (message) => {
  let merchantId = null;
  if (message) {
    const match = message.match(/\d+/); // 使用正则表达式匹配数字部分
    if (match) {
      merchantId = match[0];
    } else {
      console.log('获取供应商商户号失败！');
    }
    if (merchantId) {
      let url = `/login.html#/supplierSettlement?supplierMerchantId=${merchantId}`;
      let service = '/yms-shopping-service';
      window.location.href = getHrefPath(url, service);
    }
  }
};

/**
 * 当前登录商户不是分销商，弹出是否要开通分销商的确认弹窗
 * 当前登录分销商系统商户是通途商户，弹出是否要开通分销商的确认弹窗
 * 当前登录商户不是供应商，弹出是否要开通供应商的确认弹窗
 */

export const becomeDistributor = (type) => {
  let title = '';
  let okText = '';
  let content = '';
  switch (type) {
    case'supplier':
      title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001709');
      okText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001710');
      content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001696')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001697')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001698')}`;
      break;
    case 'distributor':
      title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001711');
      okText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001712');
      content = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001696')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001697')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001699')}`;
      break;
    case 'tongTool':
      title = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001711');
      okText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001712');
      content = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001713');
      break;
  }
  
  Modal.confirm({
    title: title,
    transfer: true,
    zIndex: 1000,
    render: (h) => {
      return h('div', [
        h(becomingSupplierDistributorModal, {
          props: {
            systemType: type,
            content: content,
            okText: okText,
            i18n: i18n
          }
        })
      ]);
    }
  });
  setTimeout(() => {
    let confirmFooter = document.querySelectorAll('.ivu-modal-confirm-footer');
    confirmFooter[0].style.display = 'none';
  }, 500);
};

// 商城完善信息
export const showShoppingPerfectInformation = () => {
  const PerfectConstructor = Vue.extend(shoppingPerfectInformation);
  const instance = new PerfectConstructor({
    i18n
  });
  instance.$mount();
  document.body.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.modal = true;
  });
};


// 当前商户没有开通域名站点
export const noDomainNameSite = (message) => {
  Modal.warning({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
    transfer: true,
    zIndex: 1000,
    content: `${message}`,
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000091'),
    onOk: () => {
      logoutFun();
    }
  });
};